import { File as DBFile } from "@prisma/client";
import { IKImage } from "imagekitio-react";
import { Link, LinkProps } from "remix";

export interface BoothOwnProps {
  image?: DBFile | null;
  linkProps: Omit<LinkProps, "className">;
  name: string;
  short: string | null;
}

export function Booth({ image, name, short, linkProps }: BoothOwnProps) {
  return (
    <div className="bg-white rounded-lg overflow-hidden mb-10 h-full shadow-sm">
      {image && (
        <IKImage
          className="flex-grow-0 flex-shrink-0 object-contain h-[250px] mx-auto p-5"
          key={image.url}
          path={image.url}
        />
      )}
      <div className="p-8 sm:p-9 md:p-7 xl:p-9 text-center">
        <h3>
          <Link
            className="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-4 block hover:text-primary"
            {...linkProps}
          >
            {name}
          </Link>
        </h3>
        {!!short && (
          <p className="text-base text-body-color leading-relaxed mb-7">
            {short}
          </p>
        )}
        <Link
          className="inline-block py-2 px-7 border border-slate-300 rounded-full text-base text-body-color font-medium hover:border-primary-600 hover:bg-primary-600 hover:text-white transition"
          {...linkProps}
        >
          Mehr Details
        </Link>
      </div>
    </div>
  );
}
